module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/battle//fire_3.png?v=4b6757ea";